export default __webpack_public_path__ + "static/ResumeImage-c46843322a6a2b1ee6557d130a9c7c3a.webp";